module.exports = __webpack_public_path__ + "static/media/background-1.59514875.jpg";